import { Section } from '../../app/aml-score/aml-score-config/aml-score-model';
import { COUNTRIES } from './countries';
import { PROVINCES } from './provinces';

export const getAmlScoreConfig = (): Section[] => {
  const AML_SCORE_CONFIG: Section[] = [
    {
      title: 'FIDUCIARIA',
      questions: [
        {
          id: 1,
          description: "Presente all'interno delle liste antiterrorismo",
          weight: 1,
          options: [
            { id: 1, view: 'Sì', value: 300 },
            { id: 2, view: 'No', value: 0 },
          ],
        },
        {
          id: 2,
          description: 'Indici reputazionali negativi',
          weight: 1,
          options: [
            {
              id: 3,
              view: 'Condanne penali, tributarie o amministrativi rilevanti',
              value: 300,
            },
            {
              id: 4,
              view: 'Procedimenti penali, tributarie o amministrativi rilevanti in corso',
              value: 300,
            },
            { id: 5, view: 'No', value: 0 },
          ],
        },
        {
          id: 3,
          description: 'Paese della sede legale',
          weight: 1,
          options: COUNTRIES,
        },
        {
          id: 4,
          description: 'Provincia della sede legale',
          weight: 1,
          options: PROVINCES,
          parent: '3',
          parentMatchValue: {
            view: 'Italia',
            value: 0,
            sigla2: 'IT',
            sigla3: 'ITA',
            id: 'ITA',
          },
          disabled: true,
        },
        {
          id: 5,
          description: 'Paese della sede amministrativa',
          weight: 1,
          options: COUNTRIES,
        },
        {
          id: 6,
          description: 'Provincia della sede amministrativa',
          weight: 1,
          options: PROVINCES,
          parent: '5',
          parentMatchValue: {
            view: 'Italia',
            value: 0,
            sigla2: 'IT',
            sigla3: 'ITA',
            id: 'ITA',
          },
          disabled: true,
        },
        {
          id: 7,
          description: 'Natura giuridica della fiduciaria',
          weight: 1,
          options: [
            { id: 10, view: 'SPA', value: 5 },
            {
              id: 11,
              view: 'Società di capitali (diversa da SPA)/Società di persone',
              value: 10,
            },
            { id: 12, view: 'Società semplice', value: 15 },
            {
              id: 13,
              view: 'Enti privi di personalità giuridica',
              value: 40,
            },
            {
              id: 14,
              view: 'Associazione, fondazione e altre istituzioni di carattere privato',
              value: 40,
            },
            { id: 15, view: 'Cooperativa/Consorzio', value: 40 },
            {
              id: 16,
              view: "Associazione temporanea d'impresa (ATI)",
              value: 100,
            },
            { id: 17, view: 'Trust', value: 300 },
            { id: 18, view: 'Ente ecclesiastico', value: 100 },
            { id: 19, view: 'Ente no profit', value: 300 },
            { id: 20, view: 'Altro', value: 300 },
            { id: 21, view: 'Società anonima (estera)', value: 60 },
          ],
        },
        {
          id: 8,
          description:
            'Possibilità di emissione di azioni al portatore da parte della fiduciaria',
          weight: 1,
          options: [
            { id: 22, view: 'Sì', value: 300 },
            { id: 23, view: 'No', value: 0 },
          ],
        },
        {
          id: 9,
          description: 'Attività svolta',
          weight: 1,
          options: [
            {
              id: 24,
              view: 'Attività delle società fiduciarie',
              value: 300,
            },
          ],
        },
      ],
    },
    {
      title: 'CLIENTE',
      questions: [
        {
          id: 10,
          description: "Presente all'interno delle liste antiterrorismo",
          weight: 1,
          options: [
            { id: 25, view: 'Sì', value: 300 },
            { id: 26, view: 'No', value: 0 },
          ],
        },
        {
          id: 11,
          description: 'Indici reputazionali negativi',
          weight: 1,
          options: [
            {
              id: 27,
              view: 'Condanne penali, tributarie o amministrativi rilevanti',
              value: 300,
            },
            {
              id: 28,
              view: 'Procedimenti penali, tributarie o amministrativi rilevanti in corso',
              value: 300,
            },
            { id: 29, view: 'No', value: 0 },
          ],
        },
        {
          id: 12,
          description: 'Paese della sede legale',
          weight: 1,
          options: COUNTRIES,
        },
        {
          id: 13,
          description: 'Provincia della sede legale',
          weight: 1,
          options: PROVINCES,
          parent: '12',
          parentMatchValue: {
            view: 'Italia',
            value: 0,
            sigla2: 'IT',
            sigla3: 'ITA',
            id: 'ITA',
          },
          disabled: true,
        },
        {
          id: 14,
          description: 'Paese della sede amministrativa',
          weight: 1,
          options: COUNTRIES,
        },
        {
          id: 15,
          description: 'Provincia della sede amministrativa',
          weight: 1,
          options: PROVINCES,
          parent: '14',
          parentMatchValue: {
            view: 'Italia',
            value: 0,
            sigla2: 'IT',
            sigla3: 'ITA',
            id: 'ITA',
          },
          disabled: true,
        },
        {
          id: 16,
          description:
            'Paesi collegati in maniera importante con la struttura proprietaria o di controllo',
          weight: 0.5,
          options: COUNTRIES,
        },
        /* {
          id: 17,
          description: 'Paese della sede legale della sede secondaria',
          weight: 1,
          options: COUNTRIES,
        }, */
        {
          id: 18,
          description: 'Natura giuridica del cliente',
          weight: 1,
          options: [
            { id: 36, view: 'SPA', value: 5 },
            {
              id: 37,
              view: 'Società di capitali (diversa da SPA)/Società di persone',
              value: 10,
            },
            { id: 38, view: 'Società semplice', value: 15 },
            {
              id: 39,
              view: 'Enti privi di personalità giuridica',
              value: 40,
            },
            {
              id: 40,
              view: 'Associazione, fondazione e altre istituzioni di carattere privato',
              value: 40,
            },
            { id: 41, view: 'Cooperativa/Consorzio', value: 40 },
            {
              id: 42,
              view: "Associazione temporanea d'impresa (ATI)",
              value: 100,
            },
            { id: 43, view: 'Trust', value: 300 },
            { id: 44, view: 'Ente ecclesiastico', value: 100 },
            { id: 45, view: 'Ente no profit', value: 300 },
            { id: 46, view: 'Altro', value: 300 },
            { id: 47, view: 'Società anonima (estera)', value: 60 },
          ],
        },
        {
          id: 19,
          description:
            'Possibilità di emissione di azioni al portatore da parte del cliente',
          weight: 1,
          options: [
            { id: 48, view: 'Sì', value: 300 },
            { id: 49, view: 'No', value: 0 },
          ],
        },
        {
          id: 20,
          description:
            'Presenza di società fiduciarie, società anonime, società con azioni al portatore o trust nella struttura proprietaria o di controllo',
          weight: 1,
          options: [
            { id: 50, view: 'Sì', value: 300 },
            { id: 51, view: 'No', value: 0 },
          ],
        },
        {
          id: 21,
          description:
            'Paese della sede legale delle società fiduciarie, società anonime, società con azioni al portatore o trust nella struttura proprietaria o di controllo',
          weight: 0.5,
          options: COUNTRIES,
        },
        {
          id: 22,
          description: 'Attività svolta',
          weight: 1,
          options: [
            {
              id: 53,
              view: 'Agricoltura, silvicultura e pesca',
              value: 10,
            },
            { id: 54, view: 'Altre attività di servizi', value: 10 },
            { id: 55, view: 'Altro', value: 300 },
            { id: 56, view: 'Appalti', value: 300 },
            { id: 57, view: 'Assistenza sociale', value: 10 },
            {
              id: 58,
              view: 'Attività artistiche, sportive, di intrattenimento e divertimento',
              value: 10,
            },
            {
              id: 59,
              view: 'Attività dei servizi di alloggio e di ristorazione',
              value: 50,
            },
            {
              id: 60,
              view: 'Attività delle società fiduciarie',
              value: 300,
            },
            {
              id: 61,
              view: 'Attività di famiglie e convivenze come datori di lavoro per personale domestico...',
              value: 50,
            },
            {
              id: 62,
              view: 'Attività finanziarie e assicurative',
              value: 10,
            },
            { id: 63, view: 'Attività immobiliari', value: 50 },
            { id: 64, view: 'Attività manifatturiere', value: 50 },
            {
              id: 65,
              view: 'Attività professionali, scientifiche e tecniche',
              value: 10,
            },
            { id: 66, view: 'Cambio valute', value: 300 },
            {
              id: 67,
              view: 'Commercio e/o produzione armi, difesa',
              value: 300,
            },
            {
              id: 68,
              view: 'Commercio, Riparazione di autoveicoli e motocicli',
              value: 50,
            },
            { id: 69, view: 'Compro oro', value: 300 },
            {
              id: 70,
              view: 'Computer/telefonia o beni tecnologici di largo consumo',
              value: 10,
            },
            {
              id: 71,
              view: 'Costruzione e ristrutturazioni edilizie, movimento terra',
              value: 300,
            },
            {
              id: 72,
              view: 'Estrazione di minerali da cave e miniere',
              value: 300,
            },
            {
              id: 73,
              view: 'Fornitura di acqua, reti fognarie, attività di gestione dei rifiuti e risanamento',
              value: 300,
            },
            {
              id: 74,
              view: 'fornitura di energia elettrica, gas, vapore e aria condizionata',
              value: 50,
            },
            {
              id: 75,
              view: 'Fornitura e gestione di energie rinnovabili',
              value: 300,
            },
            { id: 76, view: 'Giochi e scommesse', value: 300 },
            { id: 77, view: 'Istruzione', value: 10 },
            { id: 78, view: 'Metalli preziosi', value: 300 },
            { id: 79, view: 'Money transfer', value: 300 },
            {
              id: 80,
              view: 'Noleggio, agenzie di viaggio, servizi di supporto alle imprese',
              value: 10,
            },
            { id: 81, view: "Opere d'arte", value: 300 },
            {
              id: 82,
              view: 'Organizzazione ed organismi extraterritoriali',
              value: 10,
            },
            {
              id: 83,
              view: 'Pubblica amministrazione e Difesa; Assicurazione sociale obbligatoria',
              value: 10,
            },
            {
              id: 84,
              view: 'Raccolta e smaltimento di rifiuti',
              value: 300,
            },
            { id: 85, view: 'Sanità', value: 300 },
            {
              id: 86,
              view: 'Servizi di informazione e comunicazione',
              value: 10,
            },
            {
              id: 87,
              view: "Settori interessati dall'erogazione di fondi pubblici, anche di fonte comunitaria",
              value: 300,
            },
            { id: 88, view: 'Trasporti e magazzinaggio', value: 50 },
            { id: 89, view: 'Trasporto valori', value: 300 },
          ],
        },
        {
          id: 23,
          description: 'Intermediario bancario o finanziario',
          weight: 1,
          parent: '22',
          options: [
            {
              id: 90,
              view: "società ammesse alla quotazione su un mercato regolamentato e sottoposte ad obblighi di comunicazione che impongono l'obbligo di assicurare un'adeguata trasparenza della titolarità effettiva;",
              value: 0,
            },
            { id: 91, view: 'Poste italiane S.p.a.', value: 0 },
            { id: 92, view: 'Cassa depositi e prestiti S.p.a.', value: 0 },
            { id: 93, view: 'pubblica amministrazione', value: 0 },
            {
              id: 94,
              view: "istituzione o organismo che svolge funzioni pubbliche, conformemente al diritto dell'Unione Europea",
              value: 0,
            },
            { id: 95, view: 'banca', value: 0 },
            {
              id: 96,
              view: 'istituto di moneta elettronica (IMEL)',
              value: 0,
            },
            { id: 97, view: 'istituto di pagamento (IP)', value: 0 },
            {
              id: 98,
              view: 'società di intermediazione mobiliare (SIM)',
              value: 0,
            },
            {
              id: 99,
              view: 'società di gestione del risparmio (SGR)',
              value: 0,
            },
            {
              id: 100,
              view: 'società di investimento a capitale variabile (SICAV)',
              value: 0,
            },
            {
              id: 101,
              view: 'società di investimento a capitale fisso, mobiliare e immobiliare (SICAF)',
              value: 0,
            },
            {
              id: 102,
              view: "intermediario iscritto nell'albo previsto dall'articolo 106 TUB",
              value: 0,
            },
            { id: 103, view: 'impresa di assicurazione', value: 0 },
            {
              id: 104,
              view: "soggetto erogante micro-credito, ai sensi dell'articolo 111 TUB",
              value: 0,
            },
            {
              id: 105,
              view: "confidi o altro soggetto di cui all'articolo 112 TUB",
              value: 0,
            },
            {
              id: 106,
              view: 'intermediario bancario o finanziario estero',
              value: 0,
            },
            {
              id: 107,
              view: 'succursale insediata di intermediario bancario o finanziario estero',
              value: 0,
            },
            { id: 108, view: 'nessuno dei precedenti', value: 0 },
          ],
          parentMatchValue: {
            id: '62',
            view: 'Attività finanziarie e assicurative',
            value: 10,
          },
          disabled: true,
        },
        {
          id: 24,
          description: "Area geografica di svolgimento dell'attività",
          weight: 1,
          options: COUNTRIES,
        },
        {
          id: 25,
          description:
            'Ha ricevuto/è in procinto di ricevere finanziamenti pubblici, anche di origine comunitaria',
          weight: 1,
          options: [
            { id: 110, view: 'Sì', value: 300 },
            { id: 111, view: 'No', value: 0 },
          ],
        },
        {
          id: 26,
          description: 'Totale attivi',
          weight: 1,
          options: [
            { id: 112, view: 'fino a 500.000 euro', value: 5 },
            { id: 113, view: 'da 500.001 a 1.000.000 euro', value: 10 },
            { id: 114, view: 'da 1.000.001 a 2.000.000 euro', value: 20 },
            { id: 115, view: 'da 2.000.001 a 5.000.000 euro', value: 30 },
            { id: 116, view: 'da 5.000.001 a 10.000.000 euro', value: 40 },
            { id: 117, view: 'superiore a 10.000.000 euro', value: 50 },
          ],
        },
        {
          id: 27,
          description: 'Totale proventi',
          weight: 1,
          options: [
            { id: 118, view: 'fino a 500.000 euro', value: 5 },
            { id: 119, view: 'da 500.001 a 1.000.000 euro', value: 10 },
            { id: 120, view: 'da 1.000.001 a 2.000.000 euro', value: 15 },
            { id: 121, view: 'da 2.000.001 a 5.000.000 euro', value: 20 },
            { id: 122, view: 'da 5.000.001 a 10.000.000 euro', value: 25 },
            { id: 123, view: 'superiore a 10.000.000 euro', value: 30 },
          ],
        },
      ],
    },

    {
      title: 'ESECUTORE',
      questions: [
        {
          id: 28,
          description: 'Persona Politicamente Esposta (PEP) o PIL',
          weight: 1,
          options: [
            { id: 124, view: 'PEP', value: 300 },
            { id: 125, view: 'Legame con PEP', value: 300 },
            { id: 126, view: 'No', value: 0 },
          ],
        },
        {
          id: 29,
          description: "Presente all'interno delle liste antiterrorismo",
          weight: 1,
          options: [
            { id: 127, view: 'Sì', value: 300 },
            { id: 128, view: 'No', value: 0 },
          ],
        },
        {
          id: 30,
          description: 'Indici reputazionali negativi',
          weight: 1,
          options: [
            {
              id: 129,
              view: 'Condanne penali, tributarie o amministrativi rilevanti',
              value: 300,
            },
            {
              id: 130,
              view: 'Procedimenti penali, tributarie o amministrativi rilevanti in corso',
              value: 300,
            },
            { id: 131, view: 'No', value: 0 },
          ],
        },
        {
          id: 31,
          description: "Relazione dell'esecutore con il cliente",
          weight: 1,
          options: [
            { id: 132, view: 'Legale rappresentante', value: 3 },
            { id: 133, view: 'Procuratore', value: 3 },
            { id: 134, view: 'Delegato', value: 3 },
            { id: 135, view: 'Curatore Fallimentare', value: 3 },
            { id: 136, view: 'Altro', value: 5 },
          ],
        },
      ],
    },
    {
      title: 'TITOLARE EFFETTIVO',
      questions: [
        {
          id: 32,
          description: 'Persona Politicamente Esposta (PEP) o PIL',
          weight: 1,
          options: [
            { id: 137, view: 'PEP', value: 300 },
            { id: 138, view: 'Legame con PEP', value: 300 },
            { id: 139, view: 'No', value: 0 },
          ],
        },
        {
          id: 33,
          description: "Presente all'interno delle liste antiterrorismo",
          weight: 1,
          options: [
            { id: 140, view: 'Sì', value: 300 },
            { id: 141, view: 'No', value: 0 },
          ],
        },
        {
          id: 34,
          description: 'Indici reputazionali negativi',
          weight: 1,
          options: [
            {
              id: 142,
              view: 'Condanne penali, tributarie o amministrativi rilevanti',
              value: 300,
            },
            {
              id: 143,
              view: 'Procedimenti penali, tributarie o amministrativi rilevanti in corso',
              value: 300,
            },
            { id: 144, view: 'No', value: 0 },
          ],
        },
        {
          id: 35,
          description: 'Paese di residenza',
          weight: 1,
          options: COUNTRIES,
        },
        {
          id: 36,
          description: 'Professione',
          weight: 1,
          options: [
            { id: 146, view: 'Dipendente PA', value: 10 },
            { id: 147, view: 'Imprenditore individuale', value: 20 },
            { id: 148, view: 'Lavoratore subordinato privato', value: 10 },
            { id: 149, view: 'Casalinga', value: 30 },
            { id: 150, view: 'Autonomo/libero professionista', value: 20 },
            { id: 151, view: 'Ministro di culto', value: 10 },
            { id: 152, view: 'Non occupato', value: 30 },
            { id: 153, view: 'Studente', value: 80 },
            { id: 154, view: 'Pensionato', value: 10 },
            { id: 155, view: 'Altro', value: 50 },
          ],
        },
        {
          id: 37,
          description: "Area geografica di svolgimento dell'attività",
          weight: 1,
          options: COUNTRIES,
        },
        {
          id: 38,
          description: 'Relazione del titolare effettivo con il cliente',
          weight: 1,
          options: [
            {
              id: 157,
              view: 'Proprietà diretta superiore al 25% del capitale sociale del cliente',
              value: 3,
            },
            {
              id: 158,
              view: 'Proprietà indiretta superiore al 25% del capitale sociale del cliente',
              value: 3,
            },
            {
              id: 159,
              view: 'Controllo della maggioranza dei voti esercitabili in assemblea ordinaria',
              value: 3,
            },
            {
              id: 160,
              view: "Controllo di voti sufficienti ad esercitare un'influenza dominante in assemblea ordinaria",
              value: 3,
            },
            {
              id: 161,
              view: 'Influenza dominante attraverso particolari vincoli contrattuali',
              value: 3,
            },
            {
              id: 162,
              view: 'Persone giuridiche private - fondatore',
              value: 3,
            },
            {
              id: 163,
              view: 'Persone giuridiche private - beneficiario',
              value: 3,
            },
            {
              id: 164,
              view: 'Persone giuridiche private - titolare di poteri di rappresentanza legale, direzione e amministrazione',
              value: 3,
            },
            { id: 165, view: 'Trust - costituente/settlor', value: 3 },
            { id: 166, view: 'Trust - fiduciario/trustee', value: 3 },
            { id: 167, view: 'Trust - guardiano/protector', value: 3 },
            { id: 168, view: 'Trust - beneficiario', value: 3 },
            {
              id: 169,
              view: 'Trust - altra persona fisica che esercita il controllo sul trust o sui beni conferiti nel trust',
              value: 3,
            },
            {
              id: 170,
              view: 'In quanto titolare di poteri di rappresentanza legale, amministrazione o direzione del cliente',
              value: 3,
            },
          ],
        },
        {
          id: 39,
          description: 'Patrimonio',
          weight: 1,
          options: [
            { id: 171, view: 'fino a 500.000 euro', value: 5 },
            { id: 172, view: 'da 500.001 a 1.000.000 euro', value: 10 },
            { id: 173, view: 'da 1.000.001 a 2.000.000 euro', value: 15 },
            { id: 174, view: 'da 2.000.001 a 5.000.000 euro', value: 20 },
            { id: 175, view: 'da 5.000.001 a 10.000.000 euro', value: 25 },
            { id: 176, view: 'superiore a 10.000.000 euro', value: 30 },
          ],
        },
        {
          id: 40,
          description: 'Reddito',
          weight: 1,
          options: [
            { id: 177, view: 'fino a 100.000 euro', value: 5 },
            { id: 178, view: 'da 100.001 a 250.000 euro', value: 10 },
            { id: 179, view: 'da 250.001 a 500.000 euro', value: 15 },
            { id: 180, view: 'da 500.001 a 1.000.000 euro', value: 20 },
            { id: 181, view: 'da 1.000.001 a 2.000.000 euro', value: 25 },
            { id: 182, view: 'superiore a 2.000.000 euro', value: 30 },
          ],
        },
      ],
    },
    {
      title: 'RAPPORTO',
      questions: [
        {
          id: 41,
          description: "Comportamento tenuto dal cliente o dall'esecutore",
          weight: 1,
          options: [
            { id: 183, view: 'Nella norma', value: 0 },
            {
              id: 184,
              view: 'Si rifiuta o si mostra riluttante a fornire le informazioni richieste...',
              value: 300,
            },
            {
              id: 185,
              view: 'Senza fornire alcuna plausibile giustificazione...',
              value: 300,
            },
            {
              id: 186,
              view: 'Dimostra una preparazione e conoscenza della materia antiriciclaggio molto profonda...',
              value: 300,
            },
          ],
        },
        {
          id: 42,
          description: 'Natura del rapporto',
          weight: 1,
          options: [
            {
              id: 187,
              view: 'Commercializzazione diretta quote di fondi (se la sottoscrizione avviene presso la SGR)',
              value: 10,
            },
            { id: 188, view: 'Trasferimento quote di fondi', value: 15 },
            { id: 189, view: 'Erogazione finanziamento', value: 10 },
            {
              id: 190,
              view: 'Attività accessoria - consulenza',
              value: 15,
            },
            { id: 191, view: 'Altro', value: 40 },
          ],
        },
        {
          id: 43,
          description: 'Scopo del rapporto',
          weight: 1,
          options: [
            {
              id: 192,
              view: 'Investimento Professionale/Aziendale/Commerciale',
              value: 10,
            },
            { id: 193, view: 'Investimento conto terzi', value: 20 },
            {
              id: 194,
              view: 'Smobilizzo investimento mobiliare / immobiliare',
              value: 10,
            },
            { id: 195, view: 'Cessione di crediti', value: 15 },
            { id: 196, view: 'Altro', value: 300 },
            { id: 197, view: 'Avvio attività', value: 10 },
            {
              id: 198,
              view: 'Ristrutturazione locali per l’esercizio dell’attività',
              value: 10,
            },
            {
              id: 199,
              view: 'Ripianamento debiti, anche fiscali/tributari',
              value: 30,
            },
            {
              id: 200,
              view: 'Ristrutturazione posizione debitoria',
              value: 30,
            },
            {
              id: 201,
              view: 'Investimento in beni strumentali',
              value: 10,
            },
            {
              id: 202,
              view: 'Investimento non strumentale all’attività svolta',
              value: 50,
            },
            {
              id: 203,
              view: 'Riqualificazione patrimonio immobiliare',
              value: 30,
            },
            { id: 204, view: 'Liquidità', value: 30 },
            {
              id: 205,
              view: 'Operazione di carattere speculativo',
              value: 50,
            },
            { id: 206, view: 'Altro', value: 300 },
            {
              id: 207,
              view: 'Consulenza per attività di asset management',
              value: 10,
            },
            { id: 208, view: 'Altro', value: 300 },
          ],
        },
        {
          id: 44,
          description: 'Importo del rapporto',
          weight: 1,
          options: [
            { id: 209, view: 'fino a 250.000 euro', value: 5 },
            {
              id: 210,
              view: 'da 250.001 euro fino a 500.000 euro',
              value: 10,
            },
            {
              id: 211,
              view: 'da 500.001 euro fino a 750.000 euro',
              value: 20,
            },
            {
              id: 212,
              view: 'da 750.001 euro fino a 2.000.000 euro',
              value: 25,
            },
            { id: 213, view: 'superiore a 2.000.000 euro', value: 40 },
            { id: 214, view: 'fino a 2.500.000 €', value: 5 },
            { id: 215, view: 'da 2.500.001 a 5.000.000 €', value: 10 },
            { id: 216, view: 'da 5.000.001 a 10.000.000 €', value: 20 },
            { id: 217, view: 'da 10.000.001 a 30.000.000 €', value: 25 },
            { id: 218, view: 'superiore a 30.000.001 €', value: 40 },
            { id: 219, view: 'fino a 1.000.000 euro', value: 5 },
            {
              id: 220,
              view: 'da 1.000.001 euro fino a 5.000.000 euro',
              value: 10,
            },
            {
              id: 221,
              view: 'da 5.000.001 euro fino a 10.000.000 euro',
              value: 20,
            },
            {
              id: 222,
              view: 'da 10.000.001 euro fino a 20.000.000 euro',
              value: 25,
            },
            { id: 223, view: 'superiore a 20.000.000 euro', value: 40 },
          ],
        },
        {
          id: 45,
          description:
            "Ragionevolezza - congruità economica con la capacità economica-finanziaria del cliente/titolare effettivo e dell'origine dei fondi dichiarata",
          weight: 1,
          options: [
            { id: 224, view: 'Sì', value: 0 },
            { id: 225, view: 'No', value: 300 },
          ],
        },
        {
          id: 46,
          description:
            "Ragionevolezza - coerenza dell'attività svolta dal cliente con lo scopo del rapporto",
          weight: 1,
          options: [
            { id: 226, view: 'Sì', value: 0 },
            { id: 227, view: 'No', value: 300 },
          ],
        },
        {
          id: 47,
          description: 'Origine dei fondi impiegati',
          weight: 1,
          options: [
            {
              id: 228,
              view: 'Produzione di beni e servizi derivante dall’attività principale dell’impresa',
              value: 5,
            },
            { id: 229, view: 'Versamento soci', value: 15 },
            {
              id: 230,
              view: 'Rendita finanziaria / Disinvestimento strumenti finanziari',
              value: 5,
            },
            { id: 231, view: 'Rendita immobiliare', value: 15 },
            {
              id: 232,
              view: 'Emissione di titoli obbligazionari',
              value: 30,
            },
            { id: 233, view: 'Finanziamento bancario', value: 10 },
            { id: 234, view: 'Vendita beni strumentali', value: 15 },
            { id: 235, view: 'Incasso crediti maturati', value: 30 },
            { id: 236, view: 'Lasciti/donazioni', value: 20 },
            { id: 237, view: 'Altro', value: 40 },
          ],
        },
      ],
    },
  ];
  return AML_SCORE_CONFIG;
};
